<template>
  <section v-if="inspectableStageOptions.length" class="stage-switcher">
    <el-button plain class="stage-switcher__edge-button" :disabled="!previousInspectableStage" @click="previousInspectableStage && emit('switch-stage', previousInspectableStage)">上一阶段</el-button>
    <div class="stage-switcher__tabs">
      <template v-for="stage in inspectableStageOptions" :key="stage.key">
        <div v-if="currentStage === stage.key" class="stage-switcher__current">
          {{ stage.label }}
        </div>
        <button v-else class="stage-switcher__tab" @click="emit('switch-stage', stage.key)">
          {{ stage.label }}
        </button>
      </template>
    </div>
    <el-button plain class="stage-switcher__edge-button" :disabled="!nextInspectableStage" @click="nextInspectableStage && emit('switch-stage', nextInspectableStage)">下一阶段</el-button>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  inspectableStageOptions: Array<{ key: string; label: string }>
  currentStage: string
  previousInspectableStage: string | null
  nextInspectableStage: string | null
}>()

const emit = defineEmits<{
  (event: 'switch-stage', value: string): void
}>()
</script>

<style scoped>
.stage-switcher,
.stage-switcher__tabs {
  display: flex;
  gap: 14px;
}

.stage-switcher {
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding: 18px;
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(251, 146, 60, 0.12), transparent 24%),
    radial-gradient(circle at top right, rgba(20, 184, 166, 0.1), transparent 18%),
    linear-gradient(180deg, rgba(255, 249, 243, 0.98), rgba(255, 255, 255, 0.98));
  border: 1px solid rgba(251, 191, 36, 0.22);
  box-shadow: 0 18px 38px rgba(245, 158, 11, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.92);
  overflow: hidden;
}

.stage-switcher::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), transparent 30%, rgba(255, 255, 255, 0.16) 52%, transparent 74%);
  pointer-events: none;
}

.stage-switcher__tabs {
  position: relative;
  z-index: 1;
  flex: 1;
  flex-wrap: wrap;
  justify-content: center;
}

.stage-switcher__current,
.stage-switcher__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 58px;
  padding: 12px 20px;
  border-radius: 20px;
  text-align: center;
  font-weight: 700;
}

.stage-switcher__current {
  position: relative;
  z-index: 1;
  border: 1px solid rgba(94, 234, 212, 0.56);
  background: linear-gradient(135deg, rgba(240, 253, 250, 1), rgba(255, 255, 255, 0.98) 65%, rgba(236, 253, 245, 0.98));
  color: #0f766e;
  box-shadow: 0 14px 28px rgba(20, 184, 166, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.76);
}

.stage-switcher__tab {
  position: relative;
  z-index: 1;
  border: 1px solid rgba(251, 191, 36, 0.16);
  background: rgba(255, 255, 255, 0.82);
  color: #475569;
  cursor: pointer;
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.03);
  transition: all 0.18s ease, box-shadow 0.18s ease;
}

.stage-switcher__tab:hover {
  border-color: rgba(45, 212, 191, 0.34);
  color: #0f766e;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(20, 184, 166, 0.1);
}

.stage-switcher__edge-button {
  position: relative;
  z-index: 1;
  min-width: 132px;
  min-height: 50px;
  border-radius: 18px;
}

.stage-switcher :deep(.stage-switcher__edge-button.el-button) {
  border-color: rgba(251, 191, 36, 0.2);
  background: rgba(255, 255, 255, 0.84);
  color: #7c5a21;
  box-shadow: 0 10px 18px rgba(245, 158, 11, 0.05);
}

.stage-switcher :deep(.stage-switcher__edge-button.el-button:hover:not(.is-disabled)) {
  border-color: rgba(45, 212, 191, 0.34);
  color: #0f766e;
  background: rgba(255, 255, 255, 0.94);
}

.stage-switcher :deep(.stage-switcher__edge-button.el-button.is-disabled) {
  background: rgba(255, 255, 255, 0.56);
  border-color: rgba(226, 232, 240, 0.8);
  color: #94a3b8;
}

@media (max-width: 1080px) {
  .stage-switcher {
    flex-direction: column;
    align-items: stretch;
  }

  .stage-switcher__tabs {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .stage-switcher {
    padding: 16px;
  }

  .stage-switcher__edge-button {
    width: 100%;
  }
}
</style>